import { AgChartOptions } from 'ag-charts-community'

import { CustomAgChart } from '@fortem-monorepo/react-ag'

import { ICReportChartPrimitive } from '@/pages/funds/ic-report/components/primitives/types'
import { commodities } from '@/react-query/queries/ic-report/hooks'

export interface CommodityBCOMChartProps extends ICReportChartPrimitive {}

export const CommodityBCOMChart: React.FC<CommodityBCOMChartProps> = ({ params, options }) => {
  const query = commodities.useHistoricalEventsBcom(params)
  const data = query.data ?? []

  const mergedOptions: AgChartOptions = {
    height: 500,
    data,
    series: [
      {
        type: 'bar',
        xKey: 'event_name',
        yKey: 'daily_performance',
        yName: 'Return',
        fill: 'gray',
      },
      {
        type: 'bar',
        xKey: 'event_name',
        yKey: 'mdd',
        yName: 'Maximum Drawdown',
        fill: 'darkorange',
      },
      {
        type: 'bar',
        xKey: 'event_name',
        yKey: 'daily_volatility',
        yName: 'Daily Volatility',
        fill: 'orange',
      },
      {
        type: 'bar',
        xKey: 'event_name',
        yKey: 'worst_perf',
        yName: 'Worst Day',
        fill: 'lightgray',
      },
    ],
    axes: [
      {
        type: 'category',
        position: 'bottom',
      },
      {
        type: 'number',
        position: 'left',
        label: {
          formatter: (value) => `${(value.value * 100).toFixed(2)}%`,
        },
      },
    ],
    ...options,
  }

  return <CustomAgChart options={mergedOptions} />
}
